import './Loader.css';

export default function Loader() {
  return (
    <div className="loader-page">
      <div className="loader-wrap">
        <img src="/fivora-logo.png" alt="Fivora" className="loader-logo-img" />
        <div className="loader-ring">
          <span />
        </div>
      </div>
    </div>
  );
}
